var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-breadcrumbs',{staticClass:"pa-0 ma-0",attrs:{"items":_vm.breadcrumbs}}),_c('from-ot',{attrs:{"id":_vm.id},on:{"CrearOT":_vm.CrearOT}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }